module.exports = __webpack_public_path__ + "static/interstate-bold-d413d22bbd1673c03f0c5cf9dfca9714.woff";